import { TemplateStatusPill } from '../../automations-tab/templates-manager/template-status-pill/TemplateStatusPill';
import type { TemplateListStatus } from '../../automations-tab/templates-manager/types';
import styles from './draftStatus.module.css';

interface AutomationStatusSummaryProps {
  status: TemplateListStatus;
  summary: string;
}

export function AutomationStatusSummary({ status, summary }: AutomationStatusSummaryProps) {
  return (
    <div className={styles.summary}>
      <TemplateStatusPill status={status} />
      <span className={styles.summaryText}>{summary}</span>
    </div>
  );
}
